import parse from 'date-fns/parse'
import get from 'lodash/get'
import { date as formatDate } from '~/utils/filters'
import PrismicDOM from 'prismic-dom'

export function articleTitle (article) {
  return PrismicDOM.RichText.asText(get(article, 'data.title', []))
}

export function newsItemDate (item) {
  const date = get(item, 'data.date', null)

  return formatDate(parse(date))
}

export function newsItemURI (item) {
  return {
    name: 'cms:news-item',
    params: {
      id: get(item, 'id'),
    },
  }
}

export default {
  articleTitle,
  newsItemDate,
  newsItemURI,
}
